import React, { useEffect, useState } from 'react';
import cn from 'classnames';
import { Button, Typography } from 'ui';
import { ButtonVariants, Color, TypeScales } from 'ui/primitives';
import ChevronDown from 'ui/components/newIcons/ChevronDown';
import { ReviewSort } from 'src/modules/newCars/constants/filter';
import ReviewCard from '../../../cards/ReviewCard';
import s from './ReviewListing.module.scss';

export const ReviewListing = ({ ratingData }) => {
  const [selectedSort, setSelectedSort] = useState('');
  const [showDropDown, setShowDropDown] = useState(false);
  const [ratingSortedData, setRatingSortedData] = useState(ratingData);
  const [loadMore, setLoadMore] = useState(false);

  function handleSortSelect(sort) {
    setShowDropDown(false);
    setSelectedSort(sort);
  }
  useEffect(() => {
    if (showDropDown) {
      global.document.body.style.overflow = 'hidden';
    } else global.document.body.style.overflow = 'unset';
  }, [showDropDown]);

  function handleSorting() {
    let sortedData = {};
    if (selectedSort === ReviewSort.highestRating) {
      sortedData = ratingData?.sort((a, b) => b.totalRating - a.totalRating)
    }
    else if (selectedSort === ReviewSort.lowestRating) {
      sortedData = ratingData?.sort((a, b) => a.totalRating - b.totalRating)
    }
    else if (selectedSort === ReviewSort.newest) {
      sortedData = ratingData?.sort((a, b) => a.reviewDate - b.reviewDate)
    }
    else if (selectedSort === ReviewSort.oldest) {
      sortedData = ratingData?.sort((a, b) => b.reviewDate - a.reviewDate)
    }
    setRatingSortedData(sortedData);
  }

  useEffect(() => {
    if (selectedSort) {
      handleSorting()
    }
  }, [selectedSort]);

  return (
    <div className={s.root}>
      <div className={s.top}>
        <div className={s.left}>
          <Typography label="Park+ verified review" variant={TypeScales.h2} />
          <div className={s.customer_count}>
            <Typography
              label="30000+ "
              variant={TypeScales.h5}
              color={Color.purple_60}
              renderAs="SPAN"
            />
            <Typography
              label="happy customers and counting!"
              variant={TypeScales.h5}
              renderAs="SPAN"
            />
          </div>
        </div>
        <div className={s.right}>
          {/* <button
            type="button"
            className={cn(s.sort_btn, 'cmn_touchable_area', {
              [s.sort_active]: showDropDown,
            })}
            onClick={() => setShowDropDown(true)}
          >
            <Typography label="Sort by" variant={TypeScales.body_r} />
            <ChevronDown />
          </button> */}
          {showDropDown && (
            <div className={s.dropdown_root}>
              <div className={s.dropDown}>
                <button
                  type="button"
                  className="cmn_touchable_area"
                  onClick={() => handleSortSelect(ReviewSort.newest)}
                >
                  <Typography label="Newest" variant={TypeScales.body_para_r}
                    color={selectedSort === ReviewSort.newest ? Color.interaction_button : Color.text_default}

                  />
                </button>
                <button
                  type="button"
                  className="cmn_touchable_area"
                  onClick={() => handleSortSelect(ReviewSort.oldest)}
                >
                  <Typography label="Oldest" variant={TypeScales.body_para_r}
                    color={selectedSort === ReviewSort.oldest ? Color.interaction_button : Color.text_default}
                  />
                </button>
                <button
                  type="button"
                  className="cmn_touchable_area"
                  onClick={() => handleSortSelect(ReviewSort.highestRating)}
                >
                  <Typography
                    label="Highest rating"
                    variant={TypeScales.body_para_r}
                    color={selectedSort === ReviewSort.highestRating ? Color.interaction_button : Color.text_default}
                  />
                </button>
                <button
                  type="button"
                  className="cmn_touchable_area"
                  onClick={() => handleSortSelect(ReviewSort.lowestRating)}
                >
                  <Typography
                    label="Lowest rating"
                    variant={TypeScales.body_para_r}
                    color={selectedSort === ReviewSort.lowestRating ? Color.interaction_button : Color.text_default}
                  />
                </button>
              </div>
              <div
                className={s.overlay}
                onClick={() => setShowDropDown(false)}
                aria-hidden
              />
            </div>
          )}
        </div>
      </div>
      <div className={cn(s.bottom, { [s.full_list]: loadMore, [s.short_list]: !loadMore })}>
        {ratingSortedData?.map((obj) => (
          <ReviewCard
            title={obj?.title}
            rating={obj?.totalRating}
            description={obj?.description}
            name={obj?.name}
            date={obj?.date || obj?.publishedAt}
            key={obj?.title}
          />
        ))}
      </div>
      {ratingSortedData?.length > 5 && <div className={s.load_more_btn}>
        <Button label={`${loadMore ? "View less" : "View more"}`} variant={ButtonVariants.ButtonSecondary} onClick={() => setLoadMore((state) => !state)} />
      </div>}
    </div>
  );
};
